import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Ρυθμίσεις',
  lead: 'Το προφίλ της εταιρείας σας, η ταυτότητα και οι ρυθμίσεις απορρήτου.',
  noCompany: 'Δεν έχει επιλεγεί ενεργή εταιρεία.',
  adminOnly:
    'Μόνο ένας διαχειριστής της πλατφόρμας μπορεί να το αλλάξει — μπορείτε να δείτε τις τρέχουσες τιμές.',
  save: 'Αποθήκευση',
  nav: {
    label: 'Μενού ρυθμίσεων',
    profile: 'Προφίλ',
    branding: 'Ταυτότητα',
    privacy: 'Απόρρητο',
    modules: 'Λειτουργικές ενότητες',
  },
  profile: {
    title: 'Προφίλ',
    name: 'Όνομα οργανισμού',
    industry: 'Κλάδος',
    industryHint: 'Ελεύθερο κείμενο, π.χ. "Logistics" ή "Υγεία".',
    employeeCount: 'Αριθμός εργαζομένων',
    plan: 'Πακέτο',
    planPlaceholder: 'Δείτε Συνδρομή',
  },
  branding: {
    title: 'Ταυτότητα',
    lead: 'Το λογότυπό σας και το χρώμα έμφασης, με ζωντανή προεπισκόπηση.',
    logo: 'Μεταφόρτωση λογότυπου',
    logoHint: 'Μεταφορτώνεται αμέσως· ή συμπληρώστε παρακάτω ένα υπάρχον URL.',
    logoUrl: 'URL λογότυπου',
    upload: {
      uploading: 'Μεταφόρτωση…',
      tooLarge: 'Το αρχείο είναι πολύ μεγάλο (μέγ. 10MB).',
      invalidType: 'Μη επιτρεπτός τύπος αρχείου.',
    },
    accentColor: 'Χρώμα έμφασης',
    preview: 'Ζωντανή προεπισκόπηση',
    colors: {
      mint: 'Μέντα',
      pine: 'Πεύκο',
      ink: 'Μελάνι',
      amber: 'Κεχριμπάρι',
      coral: 'Κοράλλι',
      sky: 'Ουρανί',
    },
  },
  privacy: {
    title: 'Απόρρητο',
    lead: 'Το ελάχιστο μέγεθος ομάδας για συγκεντρωτικά στατιστικά και τι μοιράζεται η εταιρεία σας.',
    minGroupSize: 'Ελάχιστο μέγεθος ομάδας (k-ανωνυμία)',
    minGroupSizeHint:
      'Κάτω από αυτό, μια ομάδα είναι πολύ μικρή για εμφάνιση συγκεντρωτικών στατιστικών.',
    minGroupSizeValue: '{{count}} άτομα',
    effective: 'Ισχύει σήμερα: {{count}} άτομα',
    aggregatedData: 'Συγκεντρωτικά δεδομένα',
    aggregatedDataHint:
      'Εμφάνιση συγκεντρωτικών στατιστικών για ομάδες που πληρούν το ελάχιστο μέγεθος.',
    explicitConsent: 'Απαιτείται ρητή συναίνεση',
    explicitConsentHint: 'Απαιτήστε ατομική απάντηση συναίνεσης αντί για συλλογική συναίνεση.',
    dataExport: 'Εξαγωγή δεδομένων',
    dataExportHint: 'Επιτρέψτε την εξαγωγή στατιστικών δεδομένων.',
    auditLogHint: 'Οι διοικητικές ενέργειες καταγράφονται πάντα σε αρχείο ελέγχου.',
  },
  modules: {
    title: 'Λειτουργικές ενότητες',
    lead: 'Ενεργοποιήστε ή απενεργοποιήστε τις ενότητες που είναι διαθέσιμες για την εταιρεία σας.',
    vitality: 'Ζωτικότητα',
    vitalityHint: 'Παρακολούθηση ύπνου, στρες, καρδιακής συχνότητας και δραστηριότητας.',
    participation: 'Συμμετοχή',
    participationHint: 'Χωνί συμμετοχής και μετρικές δέσμευσης.',
    pilots: 'Δοκιμαστικές εκδόσεις',
    pilotsHint: 'Εκτελέστε και παρακολουθήστε πρόγραμμα πιλότων.',
    challenges: 'Προκλήσεις',
    challengesHint: 'Δημιουργήστε και διαχειρίστε προκλήσεις ευεξίας.',
    communication: 'Επικοινωνία',
    communicationHint: 'Στείλετε ειδοποιήσεις και μηνύματα στους υπαλλήλους.',
    documents: 'Έγγραφα',
    documentsHint: 'Δημοσιεύστε και διαχειρίστε έγγραφα της εταιρείας.',
    reports: 'Αναφορές',
    reportsHint: 'Δημιουργήστε και εξαγάγετε αναλυτικές αναφορές.',
    ai_coach: 'Προγραμματιστής ΤΝ',
    ai_coachHint: 'Προσωποποιημένη προγραμματοδότηση με τεχνητή νοημοσύνη.',
  },
};
